<template>
  <div id="app">
    <div data-app="true"> <!-- vuex 필요 -->
      <app-header v-if="checkCurrentPage()"></app-header>
      <transition name="nav">
        <LeftNav class="navigation" 
          v-if="checkCurrentPage()" v-show="show"
          ref="LeftNav"
          :clickNavMenu="clickNavMenu"></LeftNav>
      </transition>
      <router-view class="content-container" id="content-container"></router-view>
      <div class="sub_menu" @click="click_menu" v-if="checkCurrentPage()" ref="menuBtn">
        <v-icon class="btn">menu</v-icon>
      </div>
      <!-- <Gangnam v-if="isViewGangnam"/> -->
    </div>
  </div>
</template>

<script>
  import Header from '@/components/Header.vue'
  import LeftNav from '@/components/navigation/LeftNav.vue'
  // import Gangnam from '@/components/admin/Gangnam.vue'
  import { mapMutations } from 'vuex'

  export default {
    name: 'app',
    components: {
      'AppHeader': Header,
      LeftNav
      // Gangnam
    },
    data () {
      return {
        show: false,
        size: 0
      }
    },
    methods: {
      ...mapMutations([
        'setLoginStatus'
      ]),
      checkCurrentPage () { // header, nav -> 로그인, 404페이지에서 안보이게
        let loginPage = ['login'].indexOf(this.$route.name) === -1
        let pageNotFound = ['pageNotFound'].indexOf(this.$route.name) === -1

        return loginPage && pageNotFound
      },
      click_menu () { // sub_menu btn 클릭 이벤트 - 메뉴창 표시/숨기기
        this.show = !this.show
      },
      clickNavMenu () { // width < 800 일때 메뉴 클릭 후 메뉴 숨기기
        if (window.innerWidth > 800) return
        this.show = false
      },
      clickOutsie (e) { // 메뉴 표시 중 다른 범위 클릭 시 메뉴 숨기기
        if (window.innerWidth > 800 || this.show === false) return

        let el = this.$refs.LeftNav.$el
        let btn = this.$refs.menuBtn
        let target = e.target

        if (el !== target && !el.contains(target) && btn !== target && !btn.contains(target)) {
          this.show = false
        }
      },
      showNav (event) { // winodw resize event, width < 800 이면 메뉴창 숨기기
        if (window.innerWidth > 800 && this.show === true) return
        if (window.innerWidth > 800 && this.show === false) {
          this.show = true
          return
        }
        this.show = false
      }
    },
    // computed: {
    //   ...mapState({
    //     isViewGangnam: state => state.isViewGangnam
    //   })
    // },
    created () {
      if (sessionStorage.getItem('iw_u') !== null) { // 로그인 정보가 있을때 - 로그인 후 새로고침
        this.$store.dispatch('getCampaginList') // 캠페인 리스트 ajax call
        this.$store.dispatch('getDashboardData') // dashboard ajax call
        this.setLoginStatus(0) // 로그인 상태 수정
      }
    },
    mounted () {
      window.addEventListener('resize', this.showNav)
      window.addEventListener('click', this.clickOutsie)
      this.showNav()
    },
    destroyed () {
      document.removeEventListener('resize', this.showNav)
      document.removeEventListener('click', this.clickOutsie)
    }
  }
</script>

<style>
  @import url(https://fonts.googleapis.com/earlyaccess/notosanskr.css);

  .material-icons {
    font-size: 22px;  /* Preferred icon size

    /* Support for all WebKit browsers. */
    -webkit-font-smoothing: antialiased;
    /* Support for Safari and Chrome. */
    text-rendering: optimizeLegibility;
    /* Support for Firefox. */
    -moz-osx-font-smoothing: grayscale;
    /* Support for IE. */
    font-feature-settings: 'liga';
  }
  html, body {
    margin: 0;
    padding: 0;
    height: 100vh;
    -webkit-overflow-scrolling: touch; /* ios 스크롤 부드럽게 */
  }
  body {
    font-family: 'Noto Sans KR', sans-serif;
    font-weight: normal;
    font-size: 10pt;
    overflow-y: scroll;
    background-color: #f4f6f9;
  }
  *:focus {outline: none;}
  a:link { color: black; text-decoration: none;}
  a:visited { color: black; text-decoration: none;}
  a:hover { color: black; text-decoration: none;}
  a, img {
    border: none;
    outline: none;
  }
  i {
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  @media screen and (max-width: 600px) {
    .content-container::-webkit-scrollbar, body::-webkit-scrollbar { 
      display: none; 
    }
  }
</style>

<style scoped>
  #app {
    position: relative;
  }
  .content-container {
    position: relative;
    padding-top: calc(51px + 1em);
    /* padding-bottom: 10px; */
    margin-left: 150px;
    width: calc(100% - 152px - 2.5em);
    min-height: calc(100vh - 51px - 1em);
    /* min-height: calc(100vh - 97px - 1em); */
    min-width: calc(320px - 2.5em);
    padding-left: 1.5em;
    padding-right: 1em;
  }
  .sub_menu {
    width: 45px;
    height: 45px;
    background-color: rgb(140, 140, 140);
    border-radius: 50%;
    position: fixed;
    display: none;
  }
  .btn {
    color: #fff;
    font-size: 32px;
  }
  .nav-enter-active,
  .nav-leave-active {
    transition: all .3s ease;
  }

  .nav-enter,
  .nav-leave-to{
    transform: translateX(-200px);
    opacity: 0;
  }
  
  @media screen and (max-width: 800px) {
    .content-container {
      width: 100%;
      margin-left: 0;
      padding: 0;
      padding-top: .5em;
      margin-top: 41px;
      border: none;
    }
    .sub_menu {
      display: flex;
      justify-content: center;
      align-items: center;
      right: 10px;
      bottom: 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// App.vue?40e93280